import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const customizeSlice = createSlice({
  name: "location",
  initialState: {
    loading: false,
    list: [],
    allPickupPoints: [],
    allPickupTimes: [],
    allDropPoints: [],
    priceData: {},
    allCartList: [],
    cartDetails: {},
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    pickupPoints: (state, action) => {
      state.allPickupPoints = action.payload;
    },
    pickupTimes: (state, action) => {
      state.allPickupTimes = action.payload;
    },
    dropPoints: (state, action) => {
      state.allDropPoints = action.payload;
    },
    getPriceData: (state, action) => {
      state.priceData = action.payload;
    },
    cartList: (state, action) => {
      state.allCartList = action.payload;
    },
    getCartDetailsFunc: (state, action) => {
      state.cartDetails = action.payload;
    },
  },
});

export const {
  loading,
  pickupPoints,
  pickupTimes,
  dropPoints,
  getPriceData,
  cartList,
  getCartDetailsFunc,
} = customizeSlice.actions;

export const getPickupPoints = () => async (dispatch) => {
  try {
    // dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_all_pickup_point`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    // console.log(data, "response");
    dispatch(pickupPoints(data?.pickup_points));
  } catch (error) {
    errorHandling(error);
  }
};

export const storePickupPoint = (payload) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_pickup_point`;
    const { data } = await axios.post(url, payload, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const updatePickupPoint =
  (formData, id, setForm) => async (dispatch) => {
    try {
      dispatch(loading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_pickup_point/${id}`;
      const { data } = await axios.post(url, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      setForm({});
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      errorHandling(error);
    }
  };

export const destroyPickupPoint = (id) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/destroy_pickup_point/${id}`;
    const { data } = await axios.post(
      url,
      {},
      {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      }
    );
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

///////////////////////-------------- Pickup time
export const getPickupTimes = () => async (dispatch) => {
  try {
    // dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_all_pickup_time`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    console.log(data, "response");
    dispatch(pickupTimes(data?.pickup_times));
  } catch (error) {
    errorHandling(error);
  }
};

export const storePickupTime = (payload) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_pickup_times`;
    const { data } = await axios.post(url, payload, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const updatePickupTime = (formData, id, setForm) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_pickup_times/${id}`;
    const { data } = await axios.post(url, formData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    setForm({});
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const destroyPickupTime = (id) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/destroy_pickup_times/${id}`;
    const { data } = await axios.post(
      url,
      {},
      {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      }
    );
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

// ----------------drop points-------------
export const getDropPoints = () => async (dispatch) => {
  try {
    // dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_all_drop_point`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    // console.log(data, "response");
    dispatch(dropPoints(data?.drop_points));
  } catch (error) {
    errorHandling(error);
  }
};

export const storeDropPoints = (payload) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_drop_point`;
    const { data } = await axios.post(url, payload, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const updateDropPoints = (formData, id, setForm) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_drop_point/${id}`;
    const { data } = await axios.post(url, formData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    setForm({});
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const destroyDropPoints = (id) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/destroy_drop_point/${id}`;
    const { data } = await axios.post(
      url,
      {},
      {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      }
    );
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const updateCustomizePrice = (formData, id) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_customized_price/${id}`;
    const { data } = await axios.post(url, formData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const getCustomizePrice = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_customized_price`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getPriceData(data));
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const getCartList = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_customized_packages`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(cartList(data?.data));
    dispatch(loading(false));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const getCartDetails = (id) => async (dispatch) => {
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/view_customized_package/${id}`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });

    dispatch(getCartDetailsFunc(data?.data));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    errorHandling(error);
  }
};

export default customizeSlice.reducer;
